
import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

import "./Blog.css";
import { AuthContext } from "../context/AuthContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


function BlogDetail() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [editTitle, setEditTitle] = useState("");
    const [editContent, setEditContent] = useState("");
    const [editImageUrl, setEditImageUrl] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const { user } = useContext(AuthContext);

    useEffect(() => {
        async function fetchBlog() {
            setLoading(true);
            const docRef = doc(db, "blogs", id);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setBlog({ id: docSnap.id, ...docSnap.data() });
            }
            setLoading(false);
        }
        fetchBlog();
    }, [id]);

    const startEditing = () => {
        setEditTitle(blog.title || "");
        setEditContent(blog.content || "");
        setEditImageUrl(blog.imageUrl || "");
        setEditing(true);
        setError("");
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        try {
            const docRef = doc(db, "blogs", id);
            await updateDoc(docRef, {
                title: editTitle,
                content: editContent,
                imageUrl: editImageUrl
            });
            setBlog({ ...blog, title: editTitle, content: editContent, imageUrl: editImageUrl });
            setEditing(false);
        } catch (err) {
            setError("Failed to save: " + err.message);
        }
        setSaving(false);
    };

    if (loading) return <div className="blog-container"><p>Loading...</p></div>;
    if (!blog) return <div className="blog-container"><p>Blog not found.</p></div>;

    return (
        <div className="blog-container">
            {user && (
                <button className="button" style={{ marginBottom: 16 }} onClick={startEditing}>Edit</button>
            )}
            {editing ? (<>
                <form onSubmit={handleSave} style={{ marginBottom: 16 }}>
                    <input type="text" value={editTitle} onChange={e => setEditTitle(e.target.value)} placeholder="Title" style={{ width: "100%", marginBottom: 8, padding: "10px", border: " 1px solid #ccc", borderRadius: "4px" }} />
                    <div style={{ marginBottom: "40px" }}>
                        <ReactQuill
                            value={editContent}
                            onChange={setEditContent}
                            style={{ height: "300px", marginBottom: "60px" }}
                        />
                        <input type="url" value={editImageUrl} onChange={e => setEditImageUrl(e.target.value)} placeholder="Image URL" style={{ width: "100%", marginBottom: 8, padding: "10px", border: " 1px solid #ccc", borderRadius: "4px" }} />
                    </div>
                    <button type="submit" className="button" disabled={saving}>{saving ? "Saving..." : "Save"}</button>
                    <button type="button" className="button" style={{ marginLeft: 8, background: "#888" }} onClick={() => setEditing(false)}>Cancel</button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                </form>
            </>
            ) : (
                <>
                    <br />
                    <img src={blog.imageUrl || "https://via.placeholder.com/120"} alt="blog" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 8, marginBottom: 16 }} />
                    <h2>{blog.title}</h2>
                    <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
                        {blog.date && blog.date.seconds ? new Date(blog.date.seconds * 1000).toLocaleString() : ""}
                    </div>
                    <div style={{ marginBottom: 8, color: "#555" }}>
                        <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                    </div>
                </>
            )}
        </div>
    );
}

export default BlogDetail;
